import type { FormDataConvertible, QueryStringArrayFormatOption } from './types'

export const isFormData = (value: any): value is FormData => value instanceof FormData

export function objectToFormData(
  source: Record<string, FormDataConvertible>,
  form: FormData = new FormData(),
  parentKey: string | null = null,
  queryStringArrayFormat: QueryStringArrayFormatOption = 'brackets',
): FormData {
  source = source || {}

  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      append(form, composeKey(parentKey, key, 'indices'), source[key], queryStringArrayFormat)
    }
  }

  return form
}

function composeKey(parent: string | null, key: string, format: QueryStringArrayFormatOption): string {
  if (!parent) {
    return key
  }

  return format === 'brackets' ? `${parent}[]` : `${parent}[${key}]`
}

function append(form: FormData, key: string, value: FormDataConvertible, format: QueryStringArrayFormatOption): void {
  if (Array.isArray(value)) {
    return Array.from(value.keys()).forEach((index) =>
      append(form, composeKey(key, index.toString(), format), value[index], format),
    )
  } else if (value instanceof Date) {
    return form.append(key, value.toISOString())
  } else if (value instanceof File) {
    return form.append(key, value, value.name)
  } else if (value instanceof Blob) {
    return form.append(key, value)
  } else if (typeof value === 'boolean') {
    return form.append(key, value ? '1' : '0')
  } else if (typeof value === 'string') {
    return form.append(key, value)
  } else if (typeof value === 'number') {
    return form.append(key, `${value}`)
  } else if (typeof value === 'bigint') {
    return form.append(key, value.toString())
  } else if (value === null || value === undefined) {
    return form.append(key, '')
  }

  objectToFormData(value, form, key, format)
}
